import { render, staticRenderFns } from "./PageComplaintsView.vue?vue&type=template&id=07b664aa&"
import script from "./PageComplaintsView.vue?vue&type=script&lang=ts&"
export * from "./PageComplaintsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports